import { useState, useEffect } from 'react';
import get from 'hs-lodash/get';
import AuditEventHistoryV2 from 'automation-ui-management/records/AuditHistory/AuditEventHistoryV2';
import AuditEventHistory from 'automation-ui-management/records/AuditHistory/AuditEventHistory';
import compareAuditEvents from 'automation-ui-management/records/AuditHistory/compareAuditEvents';
import { FLOW_REVISIONS_FIELDNAME } from 'automation-ui-management/queries/flowRevisionQueries';
import Raven from 'raven-js';
import { sanitizeUnenrollmentSetting } from 'automation-ui-management/revision-rollup-panel/sanitizeUnenrollmentSetting';
const REVISION_ROLLUP_RESULTS_LIMIT = 50;
export function useAuditEventRollups(revisionData, flowId, filters, isRevisionRollupMigrationUngated) {
  const [isLoading, setIsLoading] = useState(false);
  const [auditEvents, setAuditEvents] = useState(new AuditEventHistory({}));
  const [nextPage, setNextPage] = useState(undefined);
  useEffect(() => {
    setIsLoading(true);
    const revisions = get(revisionData, [FLOW_REVISIONS_FIELDNAME, 'results'], []);
    const flowRevisions = revisions.map(revision => sanitizeUnenrollmentSetting(revision));
    const after = get(revisionData, [FLOW_REVISIONS_FIELDNAME, 'paging', 'next', 'after'], undefined);
    const auditEventHistory = new AuditEventHistory({}).clearEvents().updateEvents(flowRevisions);
    if (isRevisionRollupMigrationUngated && revisionData) {
      new AuditEventHistoryV2(auditEvents).updateEvents(flowId, nextPage, REVISION_ROLLUP_RESULTS_LIMIT, filters).then(auditEventHistoryV2 => {
        const [shorterAuditEvents, longerAuditEvents] = [auditEventHistory.auditEvents, auditEventHistoryV2.auditEvents].sort((auditEventsA, auditEventsB) => auditEventsA.length < auditEventsB.length ? -1 : 1);
        const indexOfDataDifference = compareAuditEvents(longerAuditEvents, shorterAuditEvents);
        if (indexOfDataDifference === -1) {
          setAuditEvents(auditEventHistoryV2);
          setNextPage(auditEventHistoryV2.getPageId());
        } else {
          // Send a sentry message with the data that is different if there is a difference
          Raven.captureMessage('Discrepancy found in revision rollups', {
            extra: {
              index: indexOfDataDifference,
              original: auditEventHistory.auditEvents[indexOfDataDifference] && auditEventHistory.auditEvents[indexOfDataDifference],
              endpoint: auditEventHistoryV2.auditEvents[indexOfDataDifference] && auditEventHistoryV2.auditEvents[indexOfDataDifference]
            }
          });

          // If comparison fails, show original data
          setAuditEvents(auditEventHistory);
          setNextPage(after);
        }
        setIsLoading(false);
      }).catch(() => {
        setIsLoading(false);
        setAuditEvents(auditEventHistory);
        setNextPage(after);
      });
    } else {
      setIsLoading(false);
      setAuditEvents(auditEventHistory);
      setNextPage(after);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [revisionData, isRevisionRollupMigrationUngated]);
  return {
    data: {
      results: auditEvents,
      paging: {
        next: {
          after: nextPage
        }
      }
    },
    loading: isLoading
  };
}